import { AKAMAI_DEVICE_TYPE_COOKIE_VALUES } from '../constants';

/**
 * Create a sizeTypes object with properties that describe the current device.
 * @param cookieSize {String} - The current value of the URBN_DEVICE_TYPE cookie, defaults to LARGE
 * @param width {Number} - The width used to determine the sizeTypes properties, defaults to the window width
 * @return {Object} - The sizeTypes object
 */
export function determineSizeTypes(cookieSize = 'LARGE', width = window.innerWidth) {
    const sizeTypes = {};

    if (width <= 567) {
        sizeTypes.breakpoint = 'extra-small'
        sizeTypes.is_extra_small = true;
        sizeTypes.is_small = false;
        sizeTypes.is_smallish = true;
        sizeTypes.is_medium = false;
        sizeTypes.is_large = false;
        sizeTypes.is_extra_large = false;
    } else if (width >= 568 && width <= 767) {
        sizeTypes.breakpoint = 'small'
        sizeTypes.is_extra_small = false;
        sizeTypes.is_small = true;
        sizeTypes.is_smallish = true;
        sizeTypes.is_medium = false;
        sizeTypes.is_large = false;
        sizeTypes.is_extra_large = false;
    } else if (width >= 768 && width <= 1024) {
        sizeTypes.breakpoint = 'medium'
        sizeTypes.is_extra_small = false;
        sizeTypes.is_small = false;
        sizeTypes.is_smallish = false;
        sizeTypes.is_medium = true;
        sizeTypes.is_large = false;
        sizeTypes.is_extra_large = false;
    } else if (width >= 1025 && width <= 1440) {
        sizeTypes.breakpoint = 'large'
        sizeTypes.is_extra_small = false;
        sizeTypes.is_small = false;
        sizeTypes.is_smallish = false;
        sizeTypes.is_medium = false;
        sizeTypes.is_large = true;
        sizeTypes.is_extra_large = false;
    } else if (width >= 1441) {
        sizeTypes.breakpoint = 'extra-large'
        sizeTypes.is_extra_small = false;
        sizeTypes.is_small = false;
        sizeTypes.is_smallish = false;
        sizeTypes.is_medium = false;
        sizeTypes.is_large = false;
        sizeTypes.is_extra_large = true;
    } else {
        return;
    }

    return sizeTypes;
}

/**
 * Determine the current cookie value for URBN_DEVICE_TYPE based on sizeTypes
 * @param sizeTypes {Object} - An object with properties that describe the current device
 * @param cookieSize {String} - The current value of the URBN_DEVICE_TYPE cookie, defaults to LARGE
 * @return {Object} - The sizeTypes object
 */
export function determineSize(sizeTypes, cookieSize = 'LARGE') {
    if (!sizeTypes) {
        return cookieSize;
    }

    if (_.get(sizeTypes, 'is_extra_small', false) || _.get(sizeTypes, 'is_small', false)) {
        return AKAMAI_DEVICE_TYPE_COOKIE_VALUES.SMALL;
    }

    if (_.get(sizeTypes, 'is_medium', false)) {
        return AKAMAI_DEVICE_TYPE_COOKIE_VALUES.MEDIUM;
    }

    if (_.get(sizeTypes, 'is_large') || _.get(sizeTypes, 'is_extra_large')) {
        return AKAMAI_DEVICE_TYPE_COOKIE_VALUES.LARGE;
    }

    return cookieSize;
}
